
import { t } from "../lib/i18n";
/**
 * 適格請求書発行事業者番号の入力検証。
 *
 * 形式は「T」+ 数字13桁（backend の Pydantic `pattern=r"^T[0-9]{13}$"` と 1:1）。
 * 空欄は許容する: 免税事業者など未登録の仕入先が実在し、未登録なら経過措置の
 * 控除割合が適用される（`invoiceTransition` 参照）。
 */
export function isValidInvoiceNo(value: string): boolean {
  const trimmed = value.trim();
  return trimmed === "" || /^T\d{13}$/.test(trimmed);
}

export const INVOICE_NO_ERROR = "「T」+ 数字13桁で入力してください";

/** 表示用（locale 反映）。定数は宣言時に評価されるので画面側はこちらを使う。 */
export function invoiceNoError(): string {
  return t(INVOICE_NO_ERROR);
}

/** 非 JP の登録番号（VAT 等）の列幅。backend `MAX_REGISTRATION_NO_LENGTH` と 1:1。 */
export const MAX_REGISTRATION_NO_LENGTH = 20;

/**
 * 非 JP 店の登録番号は**形式を検証しない**（国ごとに書式が違う＝backend の
 * `registration_numbers.py` と同じ判断）。列幅だけを見る。空欄は許容（未入力）。
 */
export function isValidGenericRegistrationNo(value: string): boolean {
  return value.trim().length <= MAX_REGISTRATION_NO_LENGTH;
}

export const GENERIC_REGISTRATION_NO_ERROR = "登録番号は20文字以内で入力してください";

/** 表示用（locale 反映）。 */
export function genericRegistrationNoError(): string {
  return t(GENERIC_REGISTRATION_NO_ERROR);
}
